import { render, staticRenderFns } from "./ReviewActivity.vue?vue&type=template&id=186de52a&scoped=true"
import script from "./ReviewActivity.vue?vue&type=script&lang=js"
export * from "./ReviewActivity.vue?vue&type=script&lang=js"
import style0 from "./ReviewActivity.vue?vue&type=style&index=0&id=186de52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186de52a",
  null
  
)

export default component.exports